import { Component, OnInit, Input } from '@angular/core';
import { faArrowRight, faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';
import { debounceTime, Subject } from 'rxjs';
import { Project } from '../project';
import { ProjectBase } from '../project-base';
import { ProjectService } from '../project.service';
import { ConfirmationModalComponent } from '@main/confirmation-modal/confirmation-modal.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe, NgFor, NgIf } from '@angular/common';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';

@Component({
    selector: 'app-project-bases',
    templateUrl: './project-bases.component.html',
    styleUrls: ['./project-bases.component.css'],
    imports: [FaIconComponent, NgFor, DatePipe, NgIf]
})
export class ProjectBasesComponent implements OnInit {

  // Properties
  private _project: Project;
  @Input()
  set project(value: Project) {
    this._project = value;
    this.bases = value.bases;
  }
  get project(): Project {
    return this._project;
  }

  bases: ProjectBase[] = [];
  editProjectBaseSubject: Subject<ProjectBase> = new Subject();

  // Font Awesome Properties
  faArrowRight = faArrowRight;
  faCheck = faCheck;
  faTimes = faTimes;
  trackByBaseId = (_: number, base: ProjectBase) => base.id;


  constructor(private projectService: ProjectService, private modalService: NgbModal) { }

  ngOnInit(): void {
    this.prepareProjectBaseEditSubject();
  }

  // Prepare Project Base Edit Subject
  private prepareProjectBaseEditSubject(): void {
    this.editProjectBaseSubject.pipe(debounceTime(250)).subscribe((base) => {
      this.updateProjectBase(base);
    });
  }

  // Add Project Base
  addProjectBase(): void {
    const newProjectBaseContent = (document.getElementById('NEW_PROJECT_BASE') as HTMLInputElement).value;
    if (newProjectBaseContent) {
      this.projectService.addProjectBase(this.project.id, newProjectBaseContent).subscribe(() => {
        this.projectService.projectUpdated.emit();
        (document.getElementById('NEW_PROJECT_BASE') as HTMLInputElement).value = null;
      });
    }
  }

  // Project Base Editied
  projectBaseEdited(base: ProjectBase, event: InputEvent): void {
    base.content = (event.target as HTMLInputElement).value;
    this.editProjectBaseSubject.next(base);
  }

  toggleBaseCompletion(base: ProjectBase, isComplete: boolean): void {
    this.bases = this.bases.map(b =>
      b.id === base.id ? { ...b, isComplete } : b
    );

    const updated = this.bases.find(b => b.id === base.id)!;
    this.updateProjectBase(updated);
  }

  updateProjectBase(base: ProjectBase): void {
    this.projectService.updateProjectBase(this.project.id, base).subscribe((serverBase: ProjectBase) => {
      this.bases = this.bases.map(b => (b.id === base.id ? { ...b, ...serverBase } : b));
      this.projectService.projectUpdated.emit();
    });
  }

  // Delete Project Base
  deleteProjectBase(base: ProjectBase): void {
    const confirmationModalRef = this.modalService.open(ConfirmationModalComponent);
    confirmationModalRef.componentInstance.message = `Are you sure you would like to delete this project base <b>${base.content}</b>?`;
    confirmationModalRef.componentInstance.actionBtnTitle = "Delete";
    confirmationModalRef.componentInstance.confirmed.subscribe(() => {
      this.projectService.deleteProjectBase(this.project.id, base.id).subscribe(() => {
          this.projectService.projectUpdated.emit();
      });
    });
  }

  // Update Project Stage
  updateProjectStage(): void {
    if(this.projectService.projectOptionalStages?.REMOVAL) {
      this.updateStage('REMOVAL');
    }
    if(!this.projectService.projectOptionalStages?.REMOVAL && this.projectService.projectOptionalStages?.REVIEWS) {
      this.updateStage('REVIEWS');
    }
    if(!this.projectService.projectOptionalStages?.REMOVAL && !this.projectService.projectOptionalStages?.REVIEWS) {
      this.updateStage('COMPLETED');
    }
  }

  updateStage(stage: string): void {
    this.projectService.updateProjectStage(this.project.id, stage).subscribe(() => {
      this.projectService.projectUpdated.emit();
    });
  }
}
